import { render, staticRenderFns } from "./bookingPaymentDetails.vue?vue&type=template&id=0275c1e7&scoped=true"
import script from "./bookingPaymentDetails.vue?vue&type=script&lang=js"
export * from "./bookingPaymentDetails.vue?vue&type=script&lang=js"
import style0 from "./bookingPaymentDetails.vue?vue&type=style&index=0&id=0275c1e7&prod&lang=less"
import style1 from "./bookingPaymentDetails.vue?vue&type=style&index=1&id=0275c1e7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0275c1e7",
  null
  
)

export default component.exports